import React from 'react';

import { Add } from '@mui/icons-material';
import { Box, Button, Divider, Typography } from '@mui/material';
import { StyledTreeItem } from 'src/components/TreeItem';
import { IndicatorWithAlerts } from 'src/types/indicator-alert-configuration';

import { AlertInputRow } from './AlertInputRow';

type AlertNodeProps = {
  indicatorIndex: number;
  indicator: IndicatorWithAlerts;
  onUpdateAlert: (
    indicatorKey: string,
    alertId: string,
    field: string,
    value: string | number,
  ) => void;
  onAddAlert: (indicatorKey: string) => void;
  onRemoveAlert: (
    indicatorKey: string,
    alertId: string,
    id: number | null,
  ) => void;
};

export function AlertNode({
  indicatorIndex,
  indicator,
  onUpdateAlert,
  onAddAlert,
  onRemoveAlert,
}: AlertNodeProps) {
  return (
    <StyledTreeItem
      key={indicator.key}
      nodeId={indicator.key}
      label={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 1,
            pr: 2,
            pl: 1,
            borderRadius: 1,
            border: '1px solid #e0e0e0',
            my: 0.5,
          }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
            {indicator.label}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              alignItems: 'center',
            }}>
            <Typography
              variant="caption"
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
              color="text.secondary">
              {indicator.alerts.length} alerta(s)
            </Typography>
          </Box>
        </Box>
      }>
      <Box sx={{ pl: 1, pb: 2 }}>
        {indicator.alerts.length === 0 ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              px: 2,
            }}>
            <Box
              sx={{
                p: 2,
                textAlign: 'center',
                color: 'text.secondary',
                fontStyle: 'italic',
                backgroundColor: '#fafafa',
                border: '2px dashed #e0e0e0',
                borderRadius: 1,
                width: '100%',
              }}>
              Nenhum alerta adicionado. Clique em "Adicionar Alerta" para
              começar.
            </Box>

            <Button
              size="small"
              startIcon={<Add />}
              onClick={(e) => {
                e.stopPropagation();
                onAddAlert(indicator.key);
              }}
              variant="contained"
              color="primary"
              sx={{
                maxWidth: 140,
                minWidth: 'auto',
                px: 1,
                fontSize: '0.75rem',
              }}>
              Adicionar Alerta
            </Button>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={1} my={2} px={2}>
            {indicator.alerts.map((alert, index) => (
              <AlertInputRow
                key={`${indicator.key}-${index}`}
                indicatorIndex={indicatorIndex}
                alertIndex={index}
                alert={alert}
                indicatorKey={indicator.key}
                onUpdateAlert={onUpdateAlert}
                onRemoveAlert={onRemoveAlert}
              />
            ))}
            <Divider />
            <Button
              size="small"
              startIcon={<Add />}
              onClick={(e) => {
                e.stopPropagation();
                onAddAlert(indicator.key);
              }}
              variant="contained"
              color="primary"
              sx={{
                maxWidth: 140,
                minWidth: 'auto',
                px: 1,
                fontSize: '0.75rem',
              }}>
              Adicionar Alerta
            </Button>
          </Box>
        )}
      </Box>
    </StyledTreeItem>
  );
}
